import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "components/Button";
import Modal from "components/Modal";

// Reusable "Sign up to save" surface. Two modes:
// - mode="panel" (default): inline card to drop into a route that's
//   gated behind real auth (Settings/Users, Settings/Organization, etc.).
// - mode="modal": small modal that appears when a trial user tries to
//   trigger a multi-user-only action (sending invite emails, etc.).

export default function TrialNudge({
  mode = "panel",
  title = "Sign up to save your work",
  body = "Create a free account to unlock this and keep everything you've added so far.",
  onClose,
}) {
  const navigate = useNavigate();

  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: 12, maxWidth: 520 }}>
      <p style={{ margin: 0, color: "#000" }}>{body}</p>
      <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
        <Button text="Sign up" callback={() => navigate("/join")} color="#27ae60" large />
        <Button text="Log in" callback={() => navigate("/login")} lightmode />
      </div>
    </div>
  );

  if (mode === "modal") {
    return (
      <Modal title={title} closeCb={onClose}>
        {content}
      </Modal>
    );
  }

  return (
    <div
      style={{
        padding: 24,
        margin: "40px auto",
        maxWidth: 560,
        borderRadius: 8,
        background: "#fff",
        border: "1px solid #ccc",
        boxShadow: "0 6px 24px rgba(0,0,0,0.15)",
        color: "#000",
        textAlign: "center",
      }}
    >
      <h3 style={{ marginTop: 0 }}>{title}</h3>
      {content}
    </div>
  );
}
